import { DateTime } from 'luxon';

export function CompareISODateStrings(a: string | undefined, b: string | undefined, mostRecent = true): number {
  if (mostRecent) {
    return DateTime.fromISO(b || '01-01-01').toMillis() - DateTime.fromISO(a || '01-01-01').toMillis();
  } else {
    return DateTime.fromISO(a || '01-01-01').toMillis() - DateTime.fromISO(b || '01-01-01').toMillis();
  }
}

export function toDateTime(v: string | Date | DateTime): DateTime {
  if (typeof v === 'string') {
    return DateTime.fromISO(v);
  }
  if (v instanceof Date) {
    return DateTime.fromJSDate(v);
  }
  return v as DateTime;
}

export function relativeDateTime(value: string | DateTime | Date | undefined): string | null {
  if (!value) return '';
  let dt: DateTime | undefined;
  if (typeof value === 'string') {
    dt = DateTime.fromISO(value, { zone: 'utc' });
  } else if (value instanceof Date) {
    dt = DateTime.fromJSDate(value);
  }
  if (dt) {
    return dt.toRelative();
  }
  return '';
}
